import { render, staticRenderFns } from "./IbDivider.vue?vue&type=template&id=d84f9554&scoped=true"
import script from "./IbDivider.vue?vue&type=script&lang=js"
export * from "./IbDivider.vue?vue&type=script&lang=js"
import style0 from "./IbDivider.vue?vue&type=style&index=0&id=d84f9554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84f9554",
  null
  
)

export default component.exports